'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCompilerState = getCompilerState;
exports.getBabel = getBabel;
exports.getOptions = getOptions;
exports.getFileTypeInfo = getFileTypeInfo;
exports.createCompilerState = createCompilerState;
exports.initializeCompilerState = initializeCompilerState;
exports.postprocess = postprocess;

var _babelTypesPatch = require('./util/babelTypesPatch');

var _babelTypesPatch2 = _interopRequireDefault(_babelTypesPatch);

var _lscNodeTypes = require('./lscNodeTypes');

var _stdlib = require('./stdlib');

var _runtime = require('./runtime');

var _imports = require('./imports');

var _inlinedOperators = require('./inlinedOperators');

var _astLocUtils = require('ast-loc-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Singleton object, unique per Program traversal, holding relevant state.
var compilerState = {
  // DI Babel instance. Avoid unless necessary; prefer types.lsc
  babel: null

  // Root program path
  , programPath: null

  // Location mixin representing the first character in the file.
  , firstLoc: null

  // Babel Plugin options
  , opts: null

  // Babel file state entry
  , file: null

  //// Preambles
  // stdlib state
  , stdlib: null
  // helpers state
  , helpers: null
  // lightscript-runtime state
  , runtime: null,

  inlinedOperatorsEnabled: true,
  isLightScript: true,
  isLSX: false
};

function getCompilerState() {
  return compilerState;
}function getBabel() {
  return compilerState.babel;
}function getOptions() {
  return compilerState.opts;
}function getFileTypeInfo(file) {
  if (!((file == null ? null : file.opts) == null ? null : file.opts.filename)) return { isLightScript: true, isLSX: false };
  var filename = file.opts.filename;

  if (filename.includes(".lsx")) return { isLightScript: true, isLSX: true };

  if (filename === "unknown" || // eslint
  filename === "repl" || // babel-node
  filename.includes(".lsc") || filename.includes("test/fixtures")) return { isLightScript: true, isLSX: false };

  return { isLightScript: false, isLSX: false };
}function processFilename(state) {
  Object.assign(state, getFileTypeInfo(state.file));
} // This will get the position of the first non-comment token. We place imports
// and requires here because ESLint requires the corresponding string literals
// to be on top of a valid token, or it chokes.
function findFirstTokenLoc(tokens) {
  if (!tokens || tokens.length === 0) return null;

  for (var _i2 = 0, _len2 = tokens.length; _i2 < _len2; _i2++) {
    var _ref;

    var _t = tokens[_i2];
    if (_t && (!((_ref = _t.type) == null ? null : _ref.indexOf) || _t.type.indexOf("Comment") < 0)) return (0, _astLocUtils.getLoc)(_t);
  }return null;
}function createCompilerState(initialState) {
  var _ref2;

  compilerState = initialState;
  processFilename(compilerState);
  // Allow config directives to override filename processing
  if ((_ref2 = initialState.file) == null ? null : _ref2.isLightScript) compilerState.isLightScript = true;

  // Get zero-location
  var tokens = ((initialState == null ? null : initialState.file) == null ? null : initialState.file.ast) == null ? null : initialState.file.ast.tokens;
  var body = ((initialState == null ? null : initialState.programPath) == null ? null : initialState.programPath.node) == null ? null : initialState.programPath.node.body;
  var loc = findFirstTokenLoc(tokens);
  if (loc) {
    initialState.firstLoc = loc;
  } else if (body && body.length > 0) {
    initialState.firstLoc = (0, _astLocUtils.span)((0, _astLocUtils.getLoc)(body[0]), 1);
  } else {
    initialState.firstLoc = {
      start: 0,
      end: 1,
      loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 1 } }
    };
  }return compilerState;
}function initializeCompilerState() {
  var _compilerState = compilerState,
      babel = _compilerState.babel,
      opts = _compilerState.opts;

  (0, _babelTypesPatch2.default)(babel.types);
  (0, _lscNodeTypes.registerLightscriptNodeTypes)(babel.types);

  compilerState.stdlib = (0, _stdlib.initializeStdlib)(opts);
  compilerState.inlinedOperatorsEnabled = (0, _inlinedOperators.getInlinedOperatorsEnabled)(opts);
  compilerState.runtime = (0, _runtime.initializeRuntime)(opts);

  return compilerState;
}function postprocess(state) {
  var stdlib = state.stdlib,
      programPath = state.programPath,
      runtime = state.runtime;

  (0, _imports.insertImports)(stdlib.imports, programPath, stdlib.useRequire || state.opts.useRequire);
  return (0, _imports.insertImports)(runtime.imports, programPath, state.opts.useRequire);
}